import { render } from "./MultiToggleSwitch.vue?vue&type=template&id=ac0a42ae"
import script from "./MultiToggleSwitch.vue?vue&type=script&lang=js"
export * from "./MultiToggleSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__